import axios from "axios";
import { ApiResponse } from "../../types/types";
import request from "../request";
import { userDataResponse, countriesObj, GetGeoLocationObj } from "./types";
import {
  FibiUsersSubscriptionPayload,
  ReserveFibiFreeTrialPayload,
  SubscriptionPaymentRes,
} from "../business/billing/types";

export const getCountries = async () => {
  return await request.get<ApiResponse<countriesObj[]>>(
    `/user/get-country-and-states`
  );
};

export const getStates = async (country?: string) => {
  return await request.get<ApiResponse<countriesObj>>(
    `/user/single-country-and-states/${country}`
  );
};

export const getUserData = async (businessId?: string) => {
  return await request.get<userDataResponse>(`/user/get-user-data`, {
    params: {
      id: businessId,
    },
  });
};

export const deleteForm = async (formCategory: string) => {
  return await request.delete<ApiResponse<string>>(
    `user/delete/${formCategory}`
  );
};

export const deleteAccount = async () => {
  return await request.delete<ApiResponse<string>>(`user/delete-account`);
};

export const getGeoLocation = async () => {
  return await axios.get<GetGeoLocationObj>(
    `https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location`
  );
};

export const fibiUsersSubscription = async (
  payload: FibiUsersSubscriptionPayload
) => {
  const { isNigeria, ...rest } = payload;

  return await request.post<SubscriptionPaymentRes>(
    `user/${
      isNigeria ? "fibi-subscription-paystack" : "fibi-subscription-stripe"
    }`,
    rest
  );
};

export const fibiUsersCancelSubscription = async () => {
  return await request.post(`/user/fibi-subscription-cancel`);
};

export const reserveFibiFreeTrial = async (
  payload: ReserveFibiFreeTrialPayload
) => {
  return await request.post(`/user/newsletter-email`, payload);
};

export const userVerifyFibiPaystack = async () => {
  return await request.post(`/user/verify-fibi-paystack-subscription`);
};

export const businessVerifyFibiPaystack = async () => {
  return await request.post(`/business/fibi-business-subscription-paystack`);
};

